import { CustomAttributeGroupHeadline } from "../CustomAttributeGroupHeadline/CustomAttributeGroupHeadline";

import type { JSX } from "react";

import Box from "@mui/material/Box";
import {
  AttributeGroupProps,
  useConfigurationGroupScrolling,
} from "@plansoft-configuration-renderer/components";

export function CustomAttributeGroupSimple(
  props: AttributeGroupProps,
): JSX.Element {
  const groupRef = useConfigurationGroupScrolling({ groupId: props.title });
  const renderWithBorder = props.custom?.renderWithBorder ?? false;

  return (
    <Box
      ref={groupRef}
      sx={{ my: "1em" }}
      className={
        "attribute-group-simple " + (renderWithBorder ? "renderWithBorder" : "")
      }
    >
      <CustomAttributeGroupHeadline {...props} />
      {props.children}
    </Box>
  );
}
